
export default (setPools: Function) => (poolId: string, value: boolean) => {
  
  return setPools((ps: any) => ps.map((item: any) => ({
    ...item,
    private: poolId === item._id ? value : item.private,
  })));
}